export const TOASTIFY_NEWEST_ON_TOP = true;
export const MESSAGES = {
  forgotPasswordSuccess:
		'Your hospital account has not been verified. Please check your email',
  forgotPasswordError: 'Error occurred while verifying the account!',
  registerSuccess: 'Please check your email to verify your hospital account.',
  registerError: 'Error occurred while signing up!',
  loginSuccess: 'You have logged in successfully!',
  loginError: 'Error occurred while logging in!',
  maxFailAttempts: 'Too many failed login attempts. Try again later.'
};
export const BG_IMAGE_URLS = {
  hospitalauthPage:
		'https://cdn.pixabay.com/photo/2021/02/03/23/09/hallway-5979689_1280.jpg',
  forgotPasswordPage:
		'https://images.pexels.com/photos/2882630/pexels-photo-2882630.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  resetPasswordPage:
		'https://images.pexels.com/photos/2882630/pexels-photo-2882630.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
};
